// Client-side stand-in for live.ts (see vite.config.ts): the catalog never
// enters the browser bundle. Pages hydrate from the events embedded in their
// own HTML and fetch the rest from /data/*.json on demand (src/data/store.ts).
import type { RawEvent } from '../types';

export const LIVE_EVENTS: RawEvent[] = [];
